// @ts-check
import React from 'react';

import Box from '@liquidweb-dev/undercurrent/Box';
import Stack from '@liquidweb-dev/undercurrent/Stack';
import SignInButton from 'components/atoms/SignInButton/SignInButton';
import CartButton from 'containers/LeftHandLayout/common/CartButton';
import { ReactComponent as LogoText } from 'images/lw-text-logo.svg';

const Unauthed = () => {
	return (
		<Box
			sx={{
				display: 'flex',
				alignItems: 'center',
				justifyContent: 'space-between',
				gap: 200,
				width: '100%',
			}}
		>
			<LogoText />
			<Stack direction="row" alignItems="center" useFlexGap gap={150}>
				<CartButton />
				<SignInButton />
			</Stack>
		</Box>
	);
};

export default Unauthed;
